import { render, staticRenderFns } from "./ProductShowModal.vue?vue&type=template&id=511f9eb1"
import script from "./ProductShowModal.vue?vue&type=script&lang=js"
export * from "./ProductShowModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports